import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route';
import { SPACE_OVERVIEW } from '@confluence/named-routes/entry-points/routes';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection';

export function RedirectToSpaceOverview({ params: { key, spaceKey }, query }: RouteMatch) {
	return <Redirection name={SPACE_OVERVIEW.name} params={{ spaceKey: key || spaceKey, query }} />;
}

RedirectToSpaceOverview.NAVIGATION_PARAMS = () => false;
